export const SET_DATE = 'SET_DATE';
export const SET_VISIBILITY = 'SET_VISIBILITY';
export const SET_TODAY = 'SET_TODAY';
export const SET_PRECISION = 'SET_PRECISION';
